<template>
    <div>
        <Modal v-model="show" title="批量更新【身份证号、岗位】" :footer-hide="true" width="400">
            <div class="tishi_txt">
                提示：不可删除ID列, 除表头外，不需要的行可以删除。
            </div>


            <div>
                <div>
                    第一步：
                    <Button @click="click_download_template" style="font-size:10px"
                        :disabled="!batch_excel_template_url">下载模板
                        <Icon type="ios-cloud-download-outline" />
                    </Button>
                </div>
                <div style="margin:20px 0">
                    第二步： 更新模板内的数据
                </div>
                <div class="upload_button_box">
                    第三步：
                    <Upload ref="upload" :action="upload_url" :on-success='upload_success' style="font-size:10px">
                        <Button icon="ios-cloud-upload-outline">上传模板</Button>
                    </Upload>

                </div>




            </div>
        </Modal>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import { throwStatement } from "@babel/types";

export default {
    name: "batch_update_info",
    data() {
        return {
            show: false,

            project_id: '',

            batch_excel_template_url: "",

            upload_file_object: '',
            upload_url: process.env.VUE_APP_HOST + '/my_project/dairuzhi/upload_upload_excel?token=' + this.$cookies.get('dx_token'),



        }
    },
    mounted() {
    },
    methods: {

        upload_success(e) {
            console.log(e)
            this.$refs.upload.clearFiles();
            this.upload_file_object = e.data.url
            this.batch_update_idcard()

        },

        click_download_template() {
            open_new_page(this.batch_excel_template_url)
        },

        get_excel_template() {

            var that = this
            var obj = {
                project_id: this.project_id,
            }
            http("post", process.env.VUE_APP_HOST + "/my_project/dairuzhi/update_excel", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        // that.$Message.success({
                        //     content: res.msg,
                        //     duration: 3,
                        // });
                        that.batch_excel_template_url = res.data.url
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },


        //更新
        batch_update_idcard() {

            var that = this
            var obj = {
                project_id: this.project_id,
                url: this.upload_file_object
            }
            console.log(obj)
            http("post", process.env.VUE_APP_HOST + "/my_project/dairuzhi/batch_update_idcard", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        open(project_id) {
            this.project_id = project_id;
            this.show = true;
            this.get_excel_template();

        },
        handleSuccess(tableData) {
            console.log('变化')
            var namelist = [];
            console.log(tableData);
            if (tableData) {
                if (tableData.columns.length > 0) {
                    var title_name = tableData.columns[0].title;
                    console.log(222, title_name)
                    namelist.push(title_name);
                }

                for (var i = 0; i < tableData.data.length; i++) {
                    console.log(1111, tableData.data[i].key0);
                    namelist.push(tableData.data[i].key0)
                }

            }
            console.log(namelist)
            this.name_list = namelist;


        },
        handleError(tableData, errorIndex) {
            console.log(tableData, errorIndex);
        }
    }

}
</script>

<style  scoped>
.upload_button_box {
    display: flex;
    align-items: center;

}

.tishi_txt {
    color: #e17a7a;
    margin-bottom: 10px;
}

.table_name_main {
    padding: 10px 0;
}

.namebox {
    padding: 1px 3px;
    background-color: #0466dd;
    color: #fff;
    margin-right: 5px;
    margin-bottom: 5px;
    font-size: 10px;
    border-radius: 3px;
}

.name_box {
    display: flex;
    flex-wrap: wrap;
}

.button_div {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
</style>